export default {
  'app.member': 'Izin anggota',
  'app.member.management': 'Manajemen Anggota',
  'app.member.management.search': 'Filter Pencarian',
  'app.member.management.invite': 'Undang Anggota Tim',
  'app.member.management.invite.sso.tip':
    'Organisasi telah mengaktifkan login SSO, dan anggota yang belum diberikan peran akan secara otomatis ditugaskan peran Default. Anda dapat memodifikasi peran mereka setelah mereka bergabung.',
  'app.member.management.invite.edit': 'Edit anggota',
  'app.member.management.invite.name.first': 'Nama Depan',
  'app.member.management.invite.name.first.placeholder': `Masukkan nama depan yang diundang`,
  'app.member.management.invite.name.first.validate': `Silakan masukkan nama depan yang diundang`,
  'app.member.management.invite.name.last': 'Nama Belakang',
  'app.member.management.invite.name.last.placeholder': `Masukkan nama belakang yang diundang`,
  'app.member.management.invite.name.last.validate': `Silakan masukkan nama belakang yang diundang`,
  'app.member.management.invite.email': 'Email Undang Anggota',
  'app.member.management.invite.email.placeholder': `Silakan masukkan email, tekan Enter untuk menambahkan`,
  'app.member.management.invite.email.validate.empty': `Silakan masukkan email yang diundang`,
  'app.member.management.invite.email.validate.right': 'Silakan masukkan email yang valid',
  'app.member.management.invite.ssoConfig': 'Layanan SSO Organisasi',
  'app.member.management.invite.ssoConfig.placeholder': 'Pilih layanan SSO organisasi',
  'app.member.management.invite.ssoConfig.validate': 'Silakan pilih layanan SSO organisasi',
  'app.member.management.invite.role': 'Peran',
  'app.member.management.invite.role.placeholder': 'Pilih peran dalam organisasi. Kirim undangan',
  'app.member.management.invite.role.empty': 'Tidak Ada Peran',
  'app.member.management.invite.role.create': 'Untuk Menambahkan Peran',
  'app.member.management.invite.role.validate':
    'Silakan pilih peran dalam organisasi. Kirim undangan',
  'app.member.management.invite.ok': 'Konfirmasi',
  'app.member.management.invite.cancel': 'Batal',
  'app.member.management.table.name': 'Nama Akun',
  'app.member.management.table.id': 'ID Akun',
  'app.member.management.table.status': 'Status Akun',
  'app.member.management.table.status.enable': 'Aktifkan',
  'app.member.management.table.status.disable': 'Nonaktifkan',
  'app.member.management.table.status.wait': 'Tunggu untuk bergabung',
  'app.member.management.table.time.last': 'Waktu kunjungan terakhir',
  'app.member.management.table.time.create': 'Waktu Pembuatan',
  'app.member.management.table.operation': 'Operasi',
  'app.member.management.table.operation.detail': 'Detail',
  'app.member.management.table.operation.edit': 'Edit',
  'app.member.management.table.operation.resend': 'Kirim Ulang',
  'app.member.management.table.operation.disable': 'Nonaktifkan',
  'app.member.management.table.operation.enable': 'Aktifkan',
  'app.member.management.table.operation.delete': 'Hapus',
  'app.member.management.table.operation.delete.confirm': 'Akun tidak tersedia setelah penghapusan',
  'app.member.management.table.operation.delete.confirm.ok': 'Konfirmasi',
  'app.member.management.table.operation.delete.confirm.cancel': 'Batal',
  'app.member.management.table.operation.invite.success': 'Undangan berhasil',
  'app.member.role': 'Manajemen Peran',
  'app.member.role.create': 'Buat peran',
  'app.member.role.edit': 'Edit peran',
  'app.member.role.create.placeholder': `Masukkan nama peran`,
  'app.member.role.admin': 'Administrator',
  'app.member.role.rights': 'Hak',
  'app.member.role.members': 'Anggota',
  'app.member.role.name.placeholder': 'Masukkan nama peran',
  'app.member.role.creater': 'Dibuat oleh',
  'app.member.role.creater.validate': 'Silakan masukkan nama pengguna Anda',
  'app.member.role.console': 'Konsol',
  'app.member.role.empty': 'Kosong',
  'app.member.role.tip': 'Peran global adalah peran preset default dari setiap proyek',
  'app.member.role.submit': 'Set berhasil!',
  'app.member.role.save': 'Simpan berhasil!',
  'app.member.role.delete':
    'Setelah menghapus peran, hak anggota yang terkait dengan peran akan menjadi tidak valid',
  'app.member.role.delete.ok': 'Hapus',
  'app.member.role.delete.cancel': 'Batal',
  'app.member.role.members.table.search': 'Filter Pencarian',
  'app.member.role.members.table.name': 'Nama Akun',
  'app.member.role.members.table.id': 'ID Akun',
  'app.member.role.members.table.emial': 'Email',
  'app.member.role.members.table.status': 'Status Akun',
  'app.member.role.members.table.status.enable': 'Aktifkan',
  'app.member.role.members.table.status.disable': 'Nonaktifkan',
  'app.member.role.members.table.status.wait': 'Tunggu untuk bergabung',
  'app.member.role.members.table.time.last': 'Waktu kunjungan terakhir',
  'app.member.role.members.table.time.create': 'Waktu Pembuatan',
  'app.member.role.members.table.operation': 'Operasi',
  'app.member.role.members.table.operation.detail': 'Detail',
  'app.member.role.members.table.operation.detail.title': 'Detail Anggota',
  'app.member.role.members.table.operation.detail.permission': 'Detail Izin',
  'app.member.role.members.table.operation.delete': 'Hapus Peran',
  'app.member.role.permission.sharing': 'Semua aplikasi berbagi izin peran',
  'app.member.role.permission.sharing.tip':
    'Setelah memeriksa dan menyimpan, izin yang dimiliki peran ini tetap konsisten di semua aplikasi.',
  'app.member.management.create.org': 'Izinkan anggota untuk membuat organisasi',
  'app.member.management.create.yes': 'Ya',
  'app.member.management.create.no': 'Tidak',
  'app.member.roleCopy.copy': 'Salin Peran',
  'app.member.roleCopy.title': 'Salin peran ke organisasi lain',
  'app.member.roleCopy.select': 'Pilih Organisasi',
  'app.member.roleCopy.selectTip': 'Silakan pilih organisasi',
  'app.member.roleCopy.all': 'Pilih Semua',
  'app.member.roleCopy.success': 'Berhasil disalin!',
  'app.member.role.otp.target.tip': `<p>1) Ketika target adalah nomor telepon:</p>
    <p>Jika operator tidak memiliki izin untuk melihat target, nomor yang ditampilkan dalam catatan sejarah akan menjadi versi yang di-desensitisasi. Ketika nomor di-desensitisasi, hanya 3 digit pertama dan 2 digit terakhir dari string nomor yang ditampilkan.</p>
    <p>2) Ketika target adalah alamat email:</p>
    <p>2 karakter pertama ditampilkan, dan alamat email tetap tidak berubah dari "{'@'}" seterusnya.</p>
    <p>Misalnya:</p>
    <p>otpsupport{'@'}engagelab.com</p>
    <p>Setelah di-desensitisasi, ditampilkan sebagai:</p>
    <p>ot***{'@'}engagelab.com</p>
    `,
};
